export const PROGRAMS = [
  {
    name: "🙂PositiveLife🙂",
    level: "Foundation",
    img: "https://images.pexels.com/photos/10595134/pexels-photo-10595134.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    desc: "Our signature program — a gentle introduction to living with positive thought, connection, health, and abundance.",
  },
  {
    name: "🙂PositiveLife🙂💃InnerWisdom💃",
    level: "Intermediate",
    img: "https://images.unsplash.com/photo-1728673429573-944fa838a631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxnb2xkZW4lMjBzdW5yaXNlJTIwbWlzdHklMjByaXZlciUyMG1lYWRvdyUyMGZsb3dlcnMlMjByZWZsZWN0aW9ufGVufDB8fHx8MTc4NzU0OTQ4OXww&ixlib=rb-4.1.0&q=85",
    desc: "Go deeper into the self with guided reflection and inner-work that quiets the mind and awakens your own inner guidance.",
  },
  {
    name: "AdvancedPositiveLife",
    level: "Advanced",
    img: "https://images.unsplash.com/photo-1727067533398-878a3a3b35ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHx3YXJtJTIwc3VucmlzZSUyMHJpdmVyJTIwcmVmbGVjdGlvbiUyMGZsb3dlcnMlMjBncmFzcyUyMG1vcm5pbmd8ZW58MHx8fHwxNzg3NTQ4MDIxfDA&ixlib=rb-4.1.0&q=85",
    desc: "A masterclass that integrates every teaching into a transformed, purpose-led way of living.",
  },
];

export const fade = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 } }),
};

export const COUNTRIES = [
  { code: "+91", name: "India", flag: "🇮🇳", len: 10 },
  { code: "+1", name: "USA / Canada", flag: "🇺🇸", len: 10 },
  { code: "+44", name: "UK", flag: "🇬🇧", len: 10 },
  { code: "+971", name: "UAE", flag: "🇦🇪", len: 9 },
  { code: "+966", name: "Saudi Arabia", flag: "🇸🇦", len: 9 },
  { code: "+65", name: "Singapore", flag: "🇸🇬", len: 8 },
  { code: "+60", name: "Malaysia", flag: "🇲🇾", min: 7, max: 10 },
  { code: "+61", name: "Australia", flag: "🇦🇺", len: 9 },
  { code: "+64", name: "New Zealand", flag: "🇳🇿", min: 8, max: 10 },
  { code: "+49", name: "Germany", flag: "🇩🇪", min: 10, max: 11 },
  { code: "+33", name: "France", flag: "🇫🇷", len: 9 },
  { code: "+81", name: "Japan", flag: "🇯🇵", min: 10, max: 11 },
  { code: "+27", name: "South Africa", flag: "🇿🇦", len: 9 },
];

export const CHECKLIST_QUESTIONS = [
  "I will attend the program with Video ON.",
  "I will share my understanding of the session in Audio Recording form daily.",
  "I will attend the Evening Guides meeting everyday at 8pm.",
  "I will do the given tasks daily.",
];
